import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import toast, { Toaster } from 'react-hot-toast';

import Statgrit_logo_main from '../../assets/Statgrit_logo_main.png';
import { userAuthTrue } from '../../redux/reducers/fotogritReducer';
import './SignIn.css';
const SignIn = () => {



  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm();

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const onSubmit = async (data) => {
    setIsLoading(true);
    try {
      await api_login(data.email, data.password);
    } finally {
      setIsLoading(false);
    }
  };

  const [token, setToken] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');

  const api_login = async (email, password) => {
    const url = `${process.env.REACT_APP_CMS_API_ROOT}` + '/pub/api/v1/login';
    const headers = {
      'Content-Type': 'application/json',
    };

    const body = {
      email: email,
      password: password,
    };

    try {
      const response = await axios.post(url, body, { headers });

      if (response.data.status === "xxx002") {
        setErrorMessage(response.data.message || 'Incorrect email or password');
        return null;
      }

      if (response.status === 200 && response.data.data) {
        const xToken = response.data.data.token;
        const profile = JSON.stringify(response.data.data.profile);

        if (xToken === '' || xToken === 'eee') {
          setErrorMessage('Invalid login credentials.');
          return null;
        } else {
          localStorage.setItem('token', xToken);
          localStorage.setItem('user_data', profile);
          setToken(xToken);
          setErrorMessage('');
          toast.success('Login successful!');
          return xToken;
        }
      } else {
        setErrorMessage(response.data.message || 'Invalid login credentials.');
        return null;
      }
    } catch (error) {
      console.error('Error occurred during login:', error);
      if (error.response?.data?.message) {
        setErrorMessage(error.response.data.message);
      } else {
        setErrorMessage('An error occurred. Please try again.');
      }
      return null;
    }
  };

  const mainToken = window.localStorage.getItem('token');
  if (mainToken) {
    navigate('/');
  }

  useEffect(() => {
    const user_data = window.localStorage.getItem('user_data');
    dispatch(
      userAuthTrue({
        user: true,
        user_data: JSON.parse(user_data),
      })
    );
  }, [token]);



  return (
    <div className='bg-[#1A1A1A] sign-in-page'>
      <Toaster />
      <div className="max-w-[1512px] px-6 md:px-12 w-full mx-auto flex  flex-col md:flex-row  sm:justify-center justify-center items-center pt-6 min-h-screen bg-[#1A1A1A]">
        <img className='max-w-[560px] w-full' src={Statgrit_logo_main} alt="Statgrit_logo_main" />

        <form onSubmit={handleSubmit(onSubmit)} className='max-w-[382px] sm:max-w-[563px] w-full p-8 border-none rounded-md bg-white'>
          <p className='text-[32px] font-bebas uppercase mb-6'>Sign IN</p>



          <div className='max-w-[334px] sm:max-w-[499px] w-full'>
            <p className='font-montserrat text-base leading-8 font-medium'>Enter Email</p>
            <input
              type="email"
              className='w-full h-[48px] text-[#636363] font-medium rounded border bg-transparent outline-none py-2 px-4'
              {...register('email', {
                required: {
                  value: true,
                  message: 'Enter Your Email',
                },
                pattern: {
                  value: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/,
                  message: 'Enter a valid email',
                },
              })}
            />

            <label className="label">
              {errors.email?.type === 'required' && (
                <span className="label-text-alt text-red-600">
                  {errors?.email?.message}
                </span>
              )}
              {errors.email?.type === 'pattern' && (
                <span className="label-text-alt text-red-600">
                  {errors?.email?.message}
                </span>
              )}
            </label>
          </div>
          <div className='max-w-[334px] sm:max-w-[499px] w-full mt-4'>
            <p className='font-montserrat text-base leading-8 font-medium'>Password</p>

            <div className='rounded border h-[48px] justify-center items-center gap-2 py-2 px-4 flex'>
              <input
                type={showPassword ? 'text' : 'password'}
                className='w-full text-[#636363] font-medium  border-none bg-transparent outline-none '
                {...register('password', {
                  required: {
                    value: true,
                    message: 'Enter Your Password',
                  },
                  minLength: {
                    value: 6,
                    message: 'Password must be at least 6 characters long',
                  },
                })}
              />
                           <button
                type="button"
                className='max-w-[20px] w-full h-[14px] cursor-pointer flex justify-center items-center'
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? (
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M12.0003 3C17.3924 3 21.8784 6.87976 22.8189 12C21.8784 17.1202 17.3924 21 12.0003 21C6.60812 21 2.12215 17.1202 1.18164 12C2.12215 6.87976 6.60812 3 12.0003 3ZM12.0003 19C16.2359 19 19.8603 16.052 20.7777 12C19.8603 7.94803 16.2359 5 12.0003 5C7.7646 5 4.14022 7.94803 3.22278 12C4.14022 16.052 7.7646 19 12.0003 19ZM12.0003 16.5C9.51498 16.5 7.50026 14.4853 7.50026 12C7.50026 9.51472 9.51498 7.5 12.0003 7.5C14.4855 7.5 16.5003 9.51472 16.5003 12C16.5003 14.4853 14.4855 16.5 12.0003 16.5ZM12.0003 14.5C13.381 14.5 14.5003 13.3807 14.5003 12C14.5003 10.6193 13.381 9.5 12.0003 9.5C10.6196 9.5 9.50026 10.6193 9.50026 12C9.50026 13.3807 10.6196 14.5 12.0003 14.5Z"></path></svg>
                ) : (
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M17.8827 19.2968C16.1814 20.3755 14.1638 21.0002 12.0003 21.0002C6.60812 21.0002 2.12215 17.1204 1.18164 12.0002C1.61832 9.62282 2.81932 7.5129 4.52047 5.93457L1.39366 2.80777L2.80788 1.39355L22.6069 21.1925L21.1927 22.6068L17.8827 19.2968ZM5.9356 7.3497C4.60673 8.56015 3.6378 10.1672 3.22278 12.0002C4.14022 16.0521 7.7646 19.0002 12.0003 19.0002C13.5997 19.0002 15.112 18.5798 16.4243 17.8334L14.396 15.8101C13.7023 16.2472 12.8808 16.5002 12.0003 16.5002C9.51498 16.5002 7.50026 14.4854 7.50026 12.0002C7.50026 11.1196 7.75317 10.2981 8.19031 9.60442L5.9356 7.3497ZM12.9139 14.328L9.67246 11.0866C9.5613 11.3696 9.50026 11.6777 9.50026 12.0002C9.50026 13.3809 10.6196 14.5002 12.0003 14.5002C12.3227 14.5002 12.6309 14.4391 12.9139 14.328ZM20.8068 16.5925L19.376 15.1617C20.0319 14.2268 20.5154 13.1586 20.7777 12.0002C19.8603 7.94818 16.2359 5.00016 12.0003 5.00016C11.1544 5.00016 10.3329 5.11773 9.55249 5.33818L7.97446 3.76015C9.22127 3.26959 10.5793 3.00016 12.0003 3.00016C17.3924 3.00016 21.8784 6.87992 22.8189 12.0002C22.5067 13.6998 21.8038 15.2628 20.8068 16.5925ZM11.7229 7.50857C11.8146 7.50299 11.9071 7.50016 12.0003 7.50016C14.4855 7.50016 16.5003 9.51488 16.5003 12.0002C16.5003 12.0933 16.4974 12.1858 16.4919 12.2775L11.7229 7.50857Z"></path></svg>
                )}
              </button>
            </div>
            <label className="label">
              {errors.password?.type === 'required' && (
                <span className="label-text-alt text-red-600">
                  {errors?.password?.message}
                </span>
              )}
              {errors.password?.type === 'minLength' && (
                <span className="label-text-alt text-red-600">
                  {errors?.password?.message}
                </span>
              )}
            </label>
          </div>
            {errorMessage && (
            <div className="text-red-600 mb-4">
              {errorMessage}
            </div>
          )}
          <input
            className='my-6 max-w-[132px] w-full h-[44px] rounded-md text-white bg-[#A46E40] text-xl font-bebas leading-5 flex justify-center items-center cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed'
            type="submit"
            value={isLoading ? "Loading..." : "Continue"}
            disabled={isLoading}
          />
          <Link to="/forget-password" className='uppercase text-[#A46E40] text-xl font-bebas mt-[6px] mb-2 hover:underline'>
            Forget Password?
          </Link>
        </form>
      </div>
    </div>
  );
};

export default SignIn;
